"use strict";

exports.__esModule = true;
exports.DeviceDataTableProvider = void 0;
var _flatten2 = _interopRequireDefault(require("ramda/src/flatten"));
var _react = _interopRequireDefault(require("react"));
var _Device = require("../../Device");
var _Core = require("../../Core");
var _CalendarContext = require("../../Calendar/CalendarContext");
var _Time = require("../../Time");
var _API = require("../../API");
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _timeDefinitions = require("../../timeDefinitions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Loads device data items & connectdata.
 */
var _load = function load(_ref) {
  var interval = _ref.interval,
    dataAccessor = _ref.dataAccessor,
    getQuery = _ref.getQuery,
    _ref$devices = _ref.devices,
    devices = _ref$devices === void 0 ? [] : _ref$devices,
    _ref$devicesList = _ref.devicesList,
    devicesList = _ref$devicesList === void 0 ? [] : _ref$devicesList;
  var dates = [];
  if (interval.endMillis - interval.startMillis > _timeDefinitions.DAY_IN_MILLIS) {
    var i = interval.startMillis;
    while (i < interval.endMillis) {
      var next = i + _timeDefinitions.DAY_IN_MILLIS;
      next = next > interval.endMillis ? interval.endMillis : next;
      dates.push({
        startMillis: i,
        endMillis: next
      });
      i = next;
    }
  } else {
    dates.push(interval);
  }
  var allDevices = devicesList.filter(function (device) {
    return devices.includes(device.uuid);
  });
  return Promise.all((0, _flatten2["default"])(allDevices.map(function (device) {
    return dates.map(function (interval) {
      return dataAccessor.getRawS3ConnectData(getQuery(interval, device));
    });
  })));
};
var DeviceDataTableProvider = exports.DeviceDataTableProvider = function DeviceDataTableProvider(props) {
  var children = props.children,
    dataRange = props.dataRange;
  var urlFilter = _react["default"].useContext(_Core.URLFilterContext);
  var deviceContext = _react["default"].useContext(_Device.DeviceContext);
  var devicesList = _react["default"].useContext(_Device.DeviceListContext);
  var dataAccessor = _react["default"].useContext(_DataAccessorContext.DataAccessorContext);
  var reportingPeriod = _react["default"].useContext(_Time.ReportingPeriodContext);
  var _React$useContext = _react["default"].useContext(_CalendarContext.CalendarContext),
    calendar = _React$useContext.calendar;
  var selection = _react["default"].useContext(_Core.SelectionContext);
  var devices = (0, _Device.getSelectedDevices)({
    urlFilter: urlFilter,
    deviceContext: deviceContext,
    defaultDeviceList: devicesList,
    selection: selection,
    dataRange: dataRange
  });
  var getQuery = function getQuery(interval, _ref2) {
    var uuid = _ref2.uuid,
      _ref2$dataItems = _ref2.dataItems,
      dataItems = _ref2$dataItems === void 0 ? [] : _ref2$dataItems;
    return {
      data_item_names: dataItems.map(function (item) {
        return item.name;
      }).join(";"),
      containing: [new Date(interval.startMillis).toISOString(), new Date(interval.endMillis).toISOString()].join("/"),
      device_uuid: uuid,
      timezone: (calendar == null ? void 0 : calendar.timezone.name) || (calendar == null ? void 0 : calendar.timezone.id)
    };
  };
  var _getTimePeriod = (0, _Time.getTimePeriod)(reportingPeriod, selection, dataRange),
    interval = _getTimePeriod.interval;
  return /*#__PURE__*/_react["default"].createElement(_API.APIQueryController, {
    load: function load() {
      return _load({
        getQuery: getQuery,
        interval: interval,
        dataAccessor: dataAccessor,
        devices: devices,
        devicesList: devicesList
      });
    },
    normalizeResponse: _flatten2["default"],
    query: {
      reportingPeriod: reportingPeriod,
      selection: selection,
      urlFilter: urlFilter,
      deviceContext: deviceContext
    }
  }, function (_ref3) {
    var fetching = _ref3.fetching,
      loading = _ref3.loading,
      data = _ref3.data,
      error = _ref3.error,
      reload = _ref3.reload;
    if (fetching || loading) {
      return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
    }
    if (error) {
      return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
        error: error
      });
    }
    return children({
      data: data,
      reload: reload,
      fetching: fetching || loading
    });
  });
};